import axios from 'axios';

const backendUrl = import.meta.env.VITE_AUTH_URL;

const tenantApi = axios.create({
  baseURL: backendUrl,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

import type {
  TenantSocialLinks,
  TenantSupport,
} from '@features/tenant/tenantSupport';

export interface TenantBranding {
  primaryColor?: string;
  logoUrl?: string;
  socialImageUrl?: string;
  showBrandName?: boolean;
}

export type IdentityMode = 'managed' | 'delegated';

export interface TenantBootstrap {
  operationId: string;
  brandName?: string;
  identityMode: IdentityMode;
  branding?: TenantBranding;
  authProviders: string[];
  modules?: string[];
  theme?: string;
  loginUrl?: string;
  identityResolveUrl?: string;
  support?: TenantSupport;
  socialLinks?: TenantSocialLinks;
  currency?: string;
  currencyZeroDecimal?: boolean;
}

export const tenantService = {
  /**
   * Resolves the tenant from the hostname the app was loaded from.
   *
   * Public and unauthenticated on purpose: it runs before anybody logs in,
   * because what it returns decides how the login itself looks. It never
   * returns a secret.
   *
   * A 404 means no operation owns this hostname. That is not an error to
   * retry, it is an answer: the app must refuse to render rather than fall
   * back to somebody else's configuration.
   */
  async bootstrap() {
    return await tenantApi.get<TenantBootstrap>('/public/bootstrap');
  },
};
